var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSchool = function SvgSchool(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.417,
    d: "M5.991 12.2v3.924c0 .949.475 1.834 1.264 2.359l1.607 1.069a5.666 5.666 0 0 0 6.275 0l1.607-1.069a2.832 2.832 0 0 0 1.264-2.359V12.2M9.703 4.095l-6.174 3.43c-1.298.721-1.298 2.587 0 3.308l6.174 3.43a4.733 4.733 0 0 0 4.594 0l6.174-3.43c1.298-.721 1.298-2.587 0-3.308l-6.174-3.43a4.733 4.733 0 0 0-4.594 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSchool);
export default ForwardRef;